export default "__VITE_ASSET__CX3_ytJ1__"